export default "__VITE_ASSET__MdKYzdpM__"